<template>
  <!-- 신청서 뷰어 스켈레톤 로더 -->
  <div>
    <v-card class="mx-auto card-box" elevation="0">
      <v-skeleton-loader
        class="mx-auto"
        type="table-heading,list-item-two-line,list-item-three-line"
      />
    </v-card>
    <v-card class="mx-auto card-box mt-5" elevation="0">
      <v-skeleton-loader
        class="mx-auto"
        type="list-item-three-line,list-item-two-line"
      />
    </v-card>
    <v-card class="mx-auto card-box mt-5" elevation="0">
      <v-skeleton-loader
        class="mx-auto"
        type="list-item-two-line,list-item-three-line"
      />
    </v-card>
  </div>
</template>

<script>
export default {};
</script>

<style></style>
